<script>
  /**
   * Who sees one of someone else's lists, for giving a gift together
   * (wip-archive/social/SOCIAL_PHASE2_SHARING.md): everyone on a list sees the others on it. Kept
   * short however many there are — a few names, then how many more — with everyone, by name and
   * handle, a tap away.
   */
  import PersonRow from "$lib/components/PersonRow.svelte";
  import { getLocaleTag, getTranslations } from "$lib/utils/locale.svelte.js";
  import messages from "$lib/messages/shared.js";

  /**
   * @type {{
   *   owner: import("$lib/people.svelte.js").Person,
   *   others: import("$lib/people.svelte.js").Person[],
   * }}
   */
  let { owner, others } = $props();

  const t = $derived(getTranslations(messages));

  /** Names said before "and 12 others". */
  const NAMED = 3;
  let open = $state(false);

  /** @param {import("$lib/people.svelte.js").Person} person */
  const nameOf = (person) => person.firstName || `@${person.handle}`;

  const summary = $derived.by(() => {
    if (!others.length) return t("just_you", { name: nameOf(owner) });
    // All of them when that is only one more than the names would be; otherwise a count.
    const named = others.length <= NAMED + 1 ? others : others.slice(0, NAMED);
    const parts = named.map(nameOf);
    if (named.length < others.length) parts.push(t("others_more", { count: others.length - named.length }));
    return t("also_on", { names: new Intl.ListFormat(getLocaleTag(), { type: "conjunction" }).format(parts) });
  });
</script>

<div>
  <p class="text-ink-muted text-sm">{summary}</p>
  {#if others.length > 1}
    <button
      type="button"
      onclick={() => (open = !open)}
      aria-expanded={open}
      class="text-amber-deep -ml-1 flex min-h-11 items-center px-1 text-sm font-semibold">
      {open ? t("who_sees_hide") : t("who_sees_all", { count: others.length })}
    </button>
    {#if open}
      <ul class="border-hairline border-t">
        {#each others as person (person.userId)}
          <li><PersonRow {person} /></li>
        {/each}
      </ul>
    {/if}
  {/if}
</div>
